import React, { useState /* , useCallback */ } from 'react';
import styles from './index.module.less';
import moment from 'moment';
import {
  Radio,
  Button,
  Row,
  Col,
  Card,
  Empty,
  Tooltip
  // Tag
  // Popconfirm,
  // Space
} from 'antd';
//import plus from '../../images/plus.svg';
import SearchBar from '@/common/Content/searchBar';
import CustomTable from 'common/Content/CustomTable';
import {
  // EditOutlined,
  ArrowLeftOutlined,
  PlusOutlined
} from '@ant-design/icons';
import { history } from 'app/history';
//import LocalStorage from 'utilities/localStorage';
import AllExportReports from '../reports/AllExportReports';
//import { useNavigate } from 'react-router-dom';

const filters = [
  /*  {
    name: 'Gift Received',
    value: ''
  },
  {
    name: 'Pending',
    value: 'pending'
  },
  {
    name: 'Accepted',
    value: 'accepted'
  },
  {
    name: 'Rejected',
    value: 'rejected'
  } */
];

function DeclarationConfigsFlowPage({
  radiofilter,
  setRadiofilter,
  setTriggerFilter,
  page,
  setPage,
  pageSize,
  setPageSize,
  setSearchRequest,
  // adminBulkGiftConfigs,
  // adminBulkGiftConfigsLoading,
  // pagination
  adminDeclarationConfigs,
  get_admin_declaration_configsLoading,
  adminDeclarationConfigsPagination
}) {
  //const navigate = useNavigate();
  // Map bulk gift configs data for table display
  const adminDeclarationConfigsList = adminDeclarationConfigs?.map((item) => {
    return {
      key: item?.id,
      id: item?.id,
      upldFrmDate: item?.upldFrmDate || 'N/A',
      upldToDate: item?.upldToDate || 'N/A',
      fiscalYear: item?.fiscalYear || 'N/A',
      giftsFrmDate: item?.giftsFrmDate || 'N/A',
      giftsToDate: item?.giftsToDate || 'N/A',
      status:
        item?.isActive !== undefined
          ? item?.isActive
          : item?.status !== undefined
          ? item?.status
          : true,
      isActive: item?.isActive || 'N/A',
      type: item?.type || 'N/A',
      referenceId: item?.referenceId || 'N/A'
    };
  });
  console.log('adminDeclarationConfigs', adminDeclarationConfigs);
  // const handleBU_record = (record) => {
  //   console.log('RRRRRRRRR@@@@@@@@@@', record);
  //   history.push(`edit-roUsers-flow/${record.id}`);
  //   LocalStorage.setItem('roUsers_record', JSON.stringify(record));
  // };

  const [isAllExortModalOpen, setAllExortModalOpen] = useState(false);

  const columns = [
    {
      title: 'Start Date',
      dataIndex: 'upldFrmDate',
      key: 'upldFrmDate',
      ellipsis: true,
      sorter: (a, b) => a?.upldFrmDate?.localeCompare(b?.upldFrmDate),
      render: (upldFrmDate) => {
        return (
          <>
            <Tooltip
              title={
                upldFrmDate ? moment(upldFrmDate).format('DD MMM YYYY') : 'N/A'
              }
              color={'white'}
              overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
              arrowPointAtCenter="false"
            >
              <span className={styles.text_transform}>
                {upldFrmDate
                  ? moment(upldFrmDate).format('DD MMM YYYY')
                  : 'N/A'}
              </span>
            </Tooltip>
          </>
        );
      }
    },
    {
      title: 'End Date',
      dataIndex: 'upldToDate',
      key: 'upldToDate',
      ellipsis: true,
      sorter: (a, b) => a?.upldToDate?.localeCompare(b?.upldToDate),
      render: (upldToDate) => {
        return (
          <>
            <Tooltip
              title={
                upldToDate ? moment(upldToDate).format('DD MMM YYYY') : 'N/A'
              }
              color={'white'}
              overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
              arrowPointAtCenter="false"
            >
              <span className={styles.text_transform}>
                {upldToDate ? moment(upldToDate).format('DD MMM YYYY') : 'N/A'}
              </span>
            </Tooltip>
          </>
        );
      }
    },
    {
      title: 'Fiscal Year',
      dataIndex: 'fiscalYear',
      key: 'fiscalYear',
      ellipsis: true,
      sorter: (a, b) => a?.fiscalYear?.localeCompare(b?.fiscalYear),
      render: (fiscalYear) => {
        return (
          <>
            <Tooltip
              title={fiscalYear}
              color={'white'}
              overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
              arrowPointAtCenter="false"
            >
              {fiscalYear === null || fiscalYear === '' ? 'N/A' : fiscalYear}
            </Tooltip>
          </>
        );
      }
    },
    {
      title: 'Reference ID',
      dataIndex: 'referenceId',
      key: 'referenceId',
      ellipsis: true,
      sorter: (a, b) => a?.referenceId?.localeCompare(b?.referenceId),
      render: (referenceId) => {
        return (
          <>
            <Tooltip
              title={referenceId}
              color={'white'}
              overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
              arrowPointAtCenter="false"
            >
              <span className={styles.text_transform}>
                {referenceId === null || referenceId === ''
                  ? 'N/A'
                  : referenceId}
              </span>
            </Tooltip>
          </>
        );
      }
    }
    /*   {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      //width: '120px',
      ellipsis: true,
      //sorter: (a, b) => a?.status?.localeCompare(b?.status),
      render: (status, record) => (
        <Tag
          className={`${styles.status_style}`}
          color={
            record?.status === true
              ? 'green'
              : record?.status === false
              ? 'red'
              : 'transparent'
          }
        >
          {record?.status === true ? 'ACTIVE' : 'DEACTIVATED'}
        </Tag>
      )
    } */
    /*  {
      title: 'Action',
      key: '',
      width: 180,
      render: (record) => (
        <>
          <Space size="middle">
            <Button
              type="link"
              className={`${styles.declareGift_button}`}
              onClick={() =>
                navigate(`/create-declaration-configs-flow`, {status: {id: record.id}})
              }
            >
              {record?.type}
            </Button>
          </Space>
        </>
      )
    } */
  ];

  // const visibility = useCallback((record) => {
  //   return showDisablePopup[record.id];
  // }, showDisablePopup);

  let locale = {
    emptyText: (
      <span>
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        <div className={styles.empty_state_text}>
          There are no Declaration Configs to display
        </div>
      </span>
    )
  };

  return (
    <>
      <div className={`${styles.container}`}>
        <Row className={`${styles.row_container}`}>
          <div className={`${styles.gift_container}`}>
            <div className={`${styles.myGift_title}`}>
              Configure Declaration
            </div>
            <div className={`${styles.myGift_text}`}>
              View and manage Declaration
            </div>
          </div>

          <Row>
            <Button
              className={`${styles.export_button}`}
              onClick={() => setAllExortModalOpen(true)}
            >
              Export
            </Button>
            <Button
              className={`${styles.declareGift_button}`}
              icon={<PlusOutlined />}
              onClick={() => history.push('/create-declaration-configs-flow')}
            >
              Add declaration
            </Button>
            <Button
              style={{ marginLeft: '20px' }}
              className={`${styles.declareGift_button}`}
              icon={<ArrowLeftOutlined />}
              onClick={() => history.push('/admin')}
            >
              Back
            </Button>
          </Row>
        </Row>
        <div className={`${styles.tabs_container}`}>
          <Row>
            {/* className={`${styles.row_container}`} */}
            <Col span={16}>
              <Radio.Group
                value={radiofilter}
                size="small"
                className={`${styles.button_import_style}`}
              >
                {filters.map((item, index) => {
                  return (
                    <Radio.Button
                      value={item.value}
                      key={index}
                      //className={`${styles.RadioButton_import_style}`}
                      onChange={() => {
                        window.localStorage.setItem(
                          'set_Radiofilter',
                          JSON?.stringify(item.value)
                        );
                        setRadiofilter(item.value);
                        setTriggerFilter(true);
                      }}
                    >
                      {item.name}
                    </Radio.Button>
                  );
                })}
              </Radio.Group>
            </Col>
            <Col span={8}>
              <SearchBar
                onChange={(e) => {
                  setSearchRequest(e.target.value);
                  setTriggerFilter(true);
                }}
                className={` ${styles.searchbar}`}
                inputProps={{
                  placeholder: 'Search by fiscal year'
                }}
              />
            </Col>
          </Row>
        </div>
        <Card className={`${styles.cardStyles}`}>
          <div className={`${styles.table_container}`}>
            <CustomTable
              columns={columns}
              dataSource={adminDeclarationConfigsList || []}
              locale={locale}
              loading={get_admin_declaration_configsLoading}
              pagination={{
                current: page,
                pageSize: pageSize,
                showSizeChanger: true,
                size: 'small',
                total:
                  adminDeclarationConfigsPagination?.total_records ||
                  adminDeclarationConfigsPagination?.total ||
                  0,
                onChange: (page, pageSize) => {
                  setPage(page);
                  setPageSize(pageSize);
                }
              }}
            />
          </div>
        </Card>
        {isAllExortModalOpen ? (
          <AllExportReports
            isAllExortModalOpen={isAllExortModalOpen}
            setAllExortModalOpen={setAllExortModalOpen}
            apiName={'declaration-configs'}
          />
        ) : (
          ''
        )}
      </div>
    </>
  );
}
export default DeclarationConfigsFlowPage;
